<card>
  <div class="page-toolbar mb-5">
    <form [formGroup]="searchForm">
      <input
        [translationEditableModalDirective]="['SEARCH']"
        class="input is-small"
        type="text"
        formControlName="keyword"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
      />
    </form>
  </div>
  <ng-container *ngIf="!keyword">
    <ng-container *ngFor="let section of sectionsWithPages">
      <accordion
        [title]="section.title"
        *ngxPermissionsOnly="section.permissions"
      >
        <ul>
          <ng-container *ngFor="let page of section.pages || []">
            <li *ngxPermissionsOnly="page.permissions">
              <a [routerLink]="page.link" [routerLinkActive]="['is-active']">
                <img [src]="page.icon" alt="" />
                <span [translationEditableDirective]="page.title_key">{{
                  page.title_key | translate
                }}</span>
              </a>
            </li>
          </ng-container>
        </ul>
      </accordion>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!!keyword">
    <ul>
      <ng-container *ngFor="let page of results">
        <li *ngxPermissionsOnly="page.permissions">
          <a [routerLink]="page.link" [routerLinkActive]="['is-active']">
            <img [src]="page.icon" alt="" />
            <span [translationEditableDirective]="page.title_key">{{
              page.title_key | translate
            }}</span>
          </a>
        </li>
      </ng-container>
    </ul>
    <div
      *ngIf="results.length == 0"
      class="is-flex is-justify-content-center is-align-content-center is-align-items-center"
      style="height: 300px"
    >
      <span translationEditableDirective="NOTHING_FOUND">
        {{ 'NOTHING_FOUND' | translate }}
      </span>
    </div>
  </ng-container>
</card>
